
export default (fields, comp, beforeSave, disableValidation, validationsFunction) => ({
  mixins: comp.mixins,
  components: {
    ...comp.components || {},
  },
  validations: validationsFunction ? validationsFunction : {
    ...fields.reduce((form, key) => ({
      ...form,
      [key]: {},
    }), {}),

    ...comp.validations || {},
  },
  props: {
    value: Object,
    vuelidate: Object,
    initialSource: Object,

    ...comp.props || {},
  },
  created() {
    if (comp.created) comp.created.call(this)

    this.mapInputToLocalDataVariable(this.initialSource)
    this.$nextTick(() => this.$v.$reset())

    if (this.$parent.validationCheckers) {
      this.$parent.validationCheckers.push(this.checkFormValidation)
    } else {
      this.$parent.validationCheckers = [this.checkFormValidation]
    }
  },
  mounted() {
    if (comp.mounted) comp.mounted.call(this)
  },
  data() {
    return {
      ...fields.reduce((form, key) => ({
        ...form,
        [key]: "",
      }), {}),

      ...(comp.data && comp.data()),
    }
  },
  methods: {
    checkFormValidation(force) {
      if (!force && disableValidation) return false

      this.$v.$touch()
      this.$emit("has-error", this.$v.$error)
      return this.$v.$error
    },
    mapInputToLocalDataVariable(obj = this.value) {
      if (!obj) obj = this.value || {}
      const vuelidate = this.vuelidate
      const isFromValueObj = (obj && typeof obj === "object")

      if (isFromValueObj || vuelidate) {
        fields.forEach(key => {
          if (isFromValueObj && (obj[key] || "") !== this.$v[key].$model && obj[key] !== undefined) {
            this.$v[key].$model = obj[key]
          } else if (vuelidate && vuelidate[key]) {
            this.$v[key].$model = vuelidate[key].$model
          }
        })

        const toDelete = []
        Object.keys(obj).forEach(key => {
          if (!fields.includes(key)) {
            toDelete.push(key)
          }
        })

        const newValue = {...obj}
          toDelete.forEach(key => {
          delete newValue[key]
        })
        if (toDelete.length) this.$emit("input", newValue)
      }
    },
    updateForm() {
      let data = {
        ...fields.reduce((form, key) => ({
          ...form,
          [key]: this.$v[key].$model,
        }), {}),
      }

      this.$emit("input", beforeSave ? beforeSave(data, this) : data)

      const vuelidate = this.vuelidate
      if (vuelidate) {
        fields.forEach(key => {
          if (vuelidate[key]) {
            vuelidate[key].$model = this.$v[key].$model
          }
        })
      }
    },

    ...comp.methods || {},
  },
  computed: {
    hasVuelidateError() {
      return this.$v.$error
    },

    ...comp.computed || {},
  },
  watch: {
    hasVuelidateError(error) {
      if (!error && this.$parent.removeIndexError) {
        this.$parent._removeIndexError(
          this.checkFormValidation
        )
      }
    },

    value() {
      this.mapInputToLocalDataVariable()
    },
    initialSource(val) {
      this.mapInputToLocalDataVariable(val)
    },
    vuelidate: {
      deep: true,
      handler() {
        this.mapInputToLocalDataVariable()
      },
    },

    ...fields.reduce((form, key) => ({
      ...form,
      [key]: function() {
        this.updateForm()
      },
    }), {}),

    ...comp.watch || {},
  },
})
